// ✅ src/api/tickets.js

const BASE_URL = process.env.REACT_APP_BASE_URL ?? "";
const API_BASE = `${BASE_URL}/api/tickets`;

export async function fetchTickets() {
  const res = await fetch(`${API_BASE}`, { credentials: "include" });
  return res.json();
}

export async function fetchCompletedTickets() {
  const res = await fetch(`${API_BASE}/completed`, { credentials: "include" });
  return res.json();
}

export async function fetchNotices() {
  const res = await fetch(`${API_BASE}/notices`, { credentials: "include" });
  return res.json();
}

export async function fetchTicketById(id) {
  const res = await fetch(`${API_BASE}/${id}`, { credentials: "include" });
  return res.json();
}

export async function updateTicketStatus(id, status) {
  const res = await fetch(`${API_BASE}/${id}/status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ status }),
  });
  return res.json();
}

export async function assignTicket(id, assigned_to) {
  const res = await fetch(`${API_BASE}/${id}/assign`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ assigned_to }),
  });
  return res.json();
}

export async function updateTicketImportance(id, importance) {
  const res = await fetch(`${API_BASE}/${id}/importance`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ importance }),
  });
  return res.json();
}

export async function updateFullTicket(id, payload) {
  // Payload can include: status, assigned_to, importance, newResponse, is_internal, cc_emails
  const res = await fetch(`${API_BASE}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return res.json();
}